<template>
	<div class="Cascader">
		<div class="Cascader-name">
            <div class="color-blue cp" @click="openClassificationModel">
                {{textValue}}
            </div>
        </div>
        <Dialog ref="classificationModel" :callback="enterIndustryType" :title="title" width="700">
            <div slot="mdBox" class=" maskCascader">
                <div class="input-father checkbox-group" v-for="(item,index) in industryTypeList" :key="index">
                    <radioCascader :radiodata="industryTypeList[index]" :radioname="index" :morenzhiData="morenzhi" @putchildData="putchildData"></radioCascader>
                </div>
            </div>
		</Dialog>
	</div>
</template>
<script>
import Dialog from './dialog.vue';
import radioCascader from './radioCascader.vue';
export default {
    name: "platTypeCascader",
    components:{radioCascader,Dialog},
    computed:{

    },
    props: {
		title:{
			type:String,
			default:''
		},
        industryTypeList:{
            type:Object||Array,
            default:{}
        },
        morenzhi:{
            type:Object,
            default:{}
        }
	},
    data() {
        return {
            industryTypeName:[],//显示的行业分类名称
            lishiIndustryTypeName:[],//临时显示的行业分类名称
            industryTypeId:[],//显示的行业分类ID
            industryTypeSecondary:'',//行业二级分类
            childlist_:{},
            textValue:'全部'
        }
    },
    mounted() {
        
    },
	watch:{
		industryTypeList:{
            handler(){

            },immediate:true
        },
        morenzhi:{
            handler(){
                if(this.morenzhi){
                    let arr = [];
                    for(let item in this.morenzhi){
                        arr = arr.concat(this.morenzhi[item])
                    }
                    if(arr.length>0){
                        this.textValue = `已选${arr.length}个`;
                    }else{
                        this.textValue = '全部';
                    }
                    //console.log(arr,1)
                }else{
                    this.textValue = '全部';
                }
            },immediate:true,
            deep:true
        }
	},
    methods: {
        // 打开行业分类
        openClassificationModel (){
            let ids = this.industryTypeSecondary;
            this.industryTypeId = ids === '' ? [] : ids.split(',');
            this.lishiIndustryTypeName = [...this.industryTypeName];
            this.$refs.classificationModel.showMaskFun();
        },
        // 确定行业分类
        enterIndustryType(){
            this.$emit('putData',this.childlist_);
            if(this.childlist_){
                let arr = [];
                for(let item in this.childlist_){
                    arr = arr.concat(this.childlist_[item])
                }
                if(arr.length>0){
                    this.textValue = `已选${arr.length}个`;
                }else{
                    this.textValue = '全部';
                }
            }else{
                this.textValue = '全部';
            }
            this.$refs.classificationModel.closeMask();
        },
        //获取子集选取的值
        putchildData(e){
           this.childlist_ = Object.assign(this.childlist_,e);
        }
    }
}
</script>
<style scoped>
    .Cascader .Cascader-name{
        height: 32px;line-height: 32px;text-align: center;width: 77px;background: rgba(0,149,235,.1);
    }
</style>



// WEBPACK FOOTER //
// src/components/platTypeCascader.vue